var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loadingCanvas)?_c('VPerfectSignature',{ref:"signaturePad",staticClass:"my-4 mx-auto myCanvas",staticStyle:{"border":"1px solid grey"},attrs:{"stroke-options":_vm.strokeOptions,"penColor":"#000"},on:{"onBegin":function($event){_vm.bandSignature = true}}}):_c('v-progress-circular',{staticClass:"ma-auto",attrs:{"indeterminate":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }